<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="transmitter()"
  [productId]="transmitter().config.mainProductId"
  [showDiscontinuedWarning]="isDiscontinued()"
  [showIncompleteWarning]="isIncompleteConfiguration()"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    @if (gasName$ | async; as gasName) {
      <div class="feature">
        <p class="odx-text--small" i18n="@@floorplan.details.transmitter.gasType">Gasart</p>
        <p>{{ gasName }}</p>
      </div>
    }

    @if (sensorName$ | async; as sensorName) {
      <div class="feature">
        <p class="odx-text--small" i18n="@@global.sensor">Sensor</p>
        <p>{{ sensorName }}</p>
      </div>
    }
    <app-floorplan-item-attachments-button
      [productItems]="productItems()"
      [attachments]="attachments()"
      [customProducts]="transmitter().products"
      [gasId]="transmitter().config.gasId"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="transmitter()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-item-detail-transmitter-form [transmitter]="transmitter()"></app-floorplan-item-detail-transmitter-form>
    </div>
  }
</app-floorplan-item-details>
